import { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';

import { PlatformConfig } from './platform.types';
import { NOP_ACCESS_CONFIG, OPO_ACCESS_CONFIG } from './platform.configs';

const PlatformContext = createContext<PlatformConfig>(NOP_ACCESS_CONFIG);
const PlatformUpdateContext = createContext<(isOpoUser: boolean) => void>(() => {});

export const PlatformProvider = ({ children }: PropsWithChildren) => {
  const [config, setConfig] = useState<PlatformConfig>(NOP_ACCESS_CONFIG);

  const updatePlatformMode = useCallback((isOpoUser: boolean) => {
    setConfig(isOpoUser ? OPO_ACCESS_CONFIG : NOP_ACCESS_CONFIG);
  }, []);

  const platformValue = useMemo(() => config, [config]);

  return (
    <PlatformUpdateContext.Provider value={updatePlatformMode}>
      <PlatformContext.Provider value={platformValue}>{children}</PlatformContext.Provider>
    </PlatformUpdateContext.Provider>
  );
};

export const usePlatform = (): PlatformConfig => {
  const context = useContext(PlatformContext);

  if (!context) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }

  return context;
};

export const useUpdatePlatformMode = () => useContext(PlatformUpdateContext);
